/*
 * Copyright (c) 2022 - present, Orangecells Innovation Lab Private Limited [https://orangecells.com]
 *
 * All rights reserved.
 */

import React from "react";
import Banner from "./Components/Banner";
import ProcessCards from "./Components/ProcessCards";
import HowWeLeverageAI from "./Components/HowWeLeverageAI";
import WhyChooseUs from "./Components/WhyChooseUs";
import VisionMission from "./Components/VisionMission";

const LandingPage = () => {
  return (
    <>
      <Banner />
      <WhyChooseUs />
      <HowWeLeverageAI />
      <ProcessCards />
      <VisionMission />
    </>
  );
};

export default LandingPage;
